<template>
  <v-app id="appKontrak" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md8 lg8>
            <v-card class="elevation-1 pa-3 non-printable">
              <v-card-text class="printable wrapper">

                <div class="page">
                  <div class="layout column align-center">
                    <img src="/static/logo-agroforestcape.png" alt="Agroforestcape" width="120" height="120">
                  </div>                

                  <div class="layout row border">
                    <div class="layout column">
                      <p class="flex my-2 text-xs-left"><b>Kontrak Pengiriman</b></p>
                      <p class="flex my-1 text-xs-left">{{kodePemesanan}}</p>
                      <p class="flex my-1 text-xs-left">{{tanggalBerlaku}}</p>
                      <p class="flex my-1 text-xs-left">Agroforestcape.com</p>
                    </div>                

                    <div class="layout column">
                      <p class="flex my-2 text-xs-right"><b>AGROFORESTCAPE</b></p>
                      <p class="flex my-1 text-xs-right">Dramaga, Bogor, Indonesia</p>
                      <p class="flex my-1 text-xs-right">Phone: 082306237345</p>
                      <p class="flex my-1 text-xs-right">Web: </p>
                    </div>                
                  </div>

                  <div class="layout column">
                    <p class="flex my-2 text-xs-left">Dokumen ini berisi catatan persetujuan kontrak antara pelanggan dan jasa penyedia pengiriman melalui diskusi antara pengirim yaitu Agroforestcape dengan pelanggan pada tanggal <b>{{tanggalSepakat}}</b></p>
                    <p class="flex my-2 text-xs-left border">Untuk informasi lebih lanjut, silahkan menghubungi Narahubung Agroforestcape di <b>082306237345</b></p>
                  </div>                

                  <div class="layout row border">
                    <div class="layout column">
                      <p class="flex my-1 text-xs-left"><b>Pelanggan</b></p>
                      <p class="flex my-1 text-xs-left"><b>{{pelanggan}}</b></p>
                      <p class="flex my-2 text-xs-left">Kode Penjualan: <b>{{kodePenjualanPenjemputan}}</b></p>
                      <p class="flex my-1 text-xs-left">Entitas: <b></b></p>
                      <p class="flex my-1 text-xs-left">Kontak: <b>{{kontakPelanggan}}</b></p>
                      <p class="flex my-1 text-xs-left">Alamat: <b></b></p>
                      <p class="flex my-1 text-xs-left">Email: <b></b></p>
                      <p class="flex my-1 text-xs-left">Website: <b></b></p>
                      <p class="flex my-1 text-xs-left">Fax: </p>
                    </div>                

                    <div class="layout column">
                      <p class="flex my-1 text-xs-left"><b>Penyedia Pengiriman</b></p>
                      <p class="flex my-1 text-xs-left"><b>{{pengirim}}</b></p>
                      <p class="flex my-2 text-xs-left">Kode Penjualan: <b>{{kodePenjualanPengiriman}}</b></p>
                      <p class="flex my-1 text-xs-left">Entitas: <b></b></p>
                      <p class="flex my-1 text-xs-left">Kontak: <b>{{kontakPengirim}}</b></p>
                      <p class="flex my-1 text-xs-left">Alamat: <b></b></p>
                      <p class="flex my-1 text-xs-left">Email: <b></b></p>
                      <p class="flex my-1 text-xs-left">Website: <b></b></p>
                      <p class="flex my-1 text-xs-left">Fax: </p>
                    </div>                
                  </div>

                  <div class="layout row border">
                    <div class="layout column">
                      <p class="flex my-1 text-xs-left"><b>Komoditas</b></p>
                      <p class="flex my-2 text-xs-left">Tipe Kontrak: <b>{{tipeKontrak}}</b></p>
                      <p class="flex my-1 text-xs-left">Komoditas: <b>{{komoditas}}</b></p>
                      <p class="flex my-1 text-xs-left">Tingkat Kualitas: <b>{{tingkatKualitas}}</b></p>
                      <p class="flex my-1 text-xs-left">Kuantitas (Ton): <b>{{kuantitas}}</b></p>
                      <p class="flex my-1 text-xs-left">Musim: <b>{{musim}}</b></p>
                      <p class="flex my-1 text-xs-left">Faktur: <b>{{faktur}}</b></p>
                      <p class="flex my-1 text-xs-left">Harga: <b>Rp {{formatPrice(harga)}}.00</b></p>
                    </div>                

                    <div class="layout column">
                      <p class="flex my-1 text-xs-left"><b>Kontrak Pengirim</b></p>
                      <p class="flex my-2 text-xs-left">Faktur: <b>{{faktur}}</b></p>
                      <p class="flex my-1 text-xs-left">Jangka Pembayaran: <b>{{jangkaPembayaran}}</b></p>
                      <p class="flex my-1 text-xs-left">Payment Rate: <b>{{komisi}}</b></p>
                      <p class="flex my-1 text-xs-left"><b>&nbsp;</b></p>
                      <p class="flex my-1 text-xs-left"><b>&nbsp;</b></p>
                      <p class="flex my-1 text-xs-left"><b>&nbsp;</b></p>
                      <p class="flex my-1 text-xs-left"><b>&nbsp;</b></p>
                    </div>                
                  </div>
                </div>

                <div class="page">
                  <div class="layout row border">
                    <div class="layout column">
                      <p class="flex my-1 text-xs-left"><b>Perhatian Khusus</b></p>
                      <p class="flex my-2 text-xs-left">Pihak pengirim disini mengikat pada Agroforestcape beserta syarat dan ketentuan secara lengkap. Silahkan menghubungi pihak Agroforestcape ketika Anda membutuhkan salinan dokumen. Kontrak ini akan menggabungkan peraturan perdagangan Republik Indonesia dan ketentuan penyelesaian permasalahan berlaku sejak dimulainya arbitrasi. Setiap perselisihan, kontroversi dan klaim yang muncul dari kontrak ini, termasuk pertanyaan mengenai eksistensi, validitas atau terminasi, harus diselesaikan dengan arbitrasi sesuai dengan ketentuan penyelesain permasalahan perdagangan Republik Indonesia pada saat terjadi arbitrasi.</p>
                      <p class="flex my-1 text-xs-left">Merujuk pada <b>http://www.kemendag.go.id/</b></p>
                    </div>                
                  </div>
                </div>

              </v-card-text>

              <v-card-actions>
                <v-btn block color="primary" @click="print" :loading="loading">Print</v-btn>
                <v-btn block color="success" @click="submit" :loading="loading">Submit</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import {HTTP} from '../../http-common';

export default {
  data: () => ({
    loading: false,

    kodePemesanan: localStorage.kontrakPesananPengirimanID,
    tanggalBerlaku: localStorage.startDatePenjemputan,
    tanggalSepakat: localStorage.currentDatePengiriman,

    pelanggan: localStorage.kontrakPelanggan,
    kodePenjualanPenjemputan: localStorage.kontrakKodePenjualanPenjemputan,
    kontakPelanggan: localStorage.kontrakKontakPelanggan,

    pengirim: localStorage.kontrakPengirim,
    kodePenjualanPengiriman: localStorage.kontrakKodePenjualanPengiriman,
    kontakPengirim: localStorage.kontrakKontakPengirim,

    tipeKontrak: localStorage.kontrakSelectKontrak,
    komoditas: localStorage.kontrakKomoditas,
    tingkatKualitas: localStorage.kontrakSelectKualitas,
    kuantitas: localStorage.kontrakKurantitas,
    musim: localStorage.kontrakMusim,
    faktur: localStorage.selectFaktur,
    harga: localStorage.kontrakHarga,
    jangkaPembayaran: localStorage.kontrakEndDatePembayaran,
    komisi: localStorage.nilaiKomisi,

  }),

  methods: {
    print(){
      window.print();
    },

    submit () {
      window.getApp.$emit('APP_KOMODITAS_SUCCESS');
    },

    formatPrice(value) {
        let val = (value/1)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }

  }

};
</script>
<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }

  h2{
    text-align: center;
  }

  .border{
    border-bottom: 1px solid;
  }

  #page-break{
    page-break-after: always;
  }

  @media all{
    .break-after {
        display: none;
    }

  }

  @media print{
    #appKontrak{
      width: 100%;
      height:100%;
      position:absolute;
      top:0px;
      bottom:0px;
      margin: auto;
      margin-top: 0px !important;
      /* border: 1px solid; */
    }

    .non-printable {
      visibility: hidden;
    }

    .printable {
      visibility: visible;
    }

    .break-after {
        display: block;
        page-break-after: always;
        position: relative;
    }

    div.page {
      page-break-after: always;
      page-break-inside: avoid;
    }
  }
</style>
